<!-- 办件详情 -->
<template>
  <div class="">
    <div class="banner">
      <div
        style="width: 1200px;margin: 0px auto;position: relative;display: flex;justify-content: space-between;align-items: center;">
        <p class="top-title">办件详情</p>
        <el-dropdown v-if="$store.state.name" class="userMenu" @command="handleCommand">
          <div class="el-dropdown-link" style="display: flex;flex-wrap: wrap;width: 67px;cursor: pointer;">
            <img src="../../assets/img/user_icon.png" alt="" srcset="">
            <span style="color:#fff;display: inline-block;width: 67px;">个人中心</span>
            <!-- <i class="el-icon-caret-bottom el-icon--right"></i> -->
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="clearfix" command="Personal">
              {{ $store.state.name }}
            </el-dropdown-item>
            <el-dropdown-item class="clearfix" command="LoginOut">
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown v-else trigger="click" class="userMenu" disabled>
          <div class="el-dropdown-link" style="display: flex;flex-wrap: wrap;width: 67px;cursor: pointer;">
            <img src="../../assets/img/user_icon.png" alt="" srcset="">
            <span style="color:#fff;display: inline-block;width: 67px;" @click="toWeiXinLogin">登录</span>
            <!-- <i class="el-icon-caret-bottom el-icon--right"></i> -->
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="clearfix">
              <!-- 李佳佳 -->
            </el-dropdown-item>
            <el-dropdown-item class="clearfix">
              <!-- 退出登录 -->
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="cont" v-loading="loading">
      <!-- 基本信息 -->
      <div class="jbxx" id="t1">
        <p class="jbxx_title">基本信息</p>
        <table cellspacing="0" style="width:100%;font-size:15px;text-align:center;margin-bottom:20px;">
          <tr>
            <td class="table_title_bg" style="min-width: 100px;">事项名称</td>
            <td class="tl">{{ details.name }}</td>
            <td class="table_title_bg" style="min-width: 100px;">受理部门</td>
            <td class="tl">{{ details.deptName }}</td>
          </tr>
          <tr>
            <td class="table_title_bg" style="min-width: 100px;">法定办结时限</td>
            <td class="tl">{{ details.statutoryCompletion }}个工作日</td>
            <td class="table_title_bg" style="min-width: 100px;">承诺办结时限</td>
            <td class="tl">{{ details.promiseCompletion }}个工作日</td>
          </tr>
          <tr>
            <td class="table_title_bg" style="min-width: 100px;">申请时间</td>
            <td class="tl" colspan="3">{{ details.createTime }}</td>
          </tr>
        </table>
      </div>
      <!-- 办件进度 -->
      <div class="bjjd">
        <p class="bjjd_title">办件进度</p>
        <el-steps :active="active" simple style="font-size:15px">
          <el-step title="待收件">
            <template slot="icon">
              <img style="width:18px;" :src="active == -1 ? ytj : active == 0 ? ytj_active : ytj">
            </template>
          </el-step>
          <el-step title="待办结">
            <template slot="icon">
              <img style="width:18px;" :src="active == -1 ? ysl : (active == 1 ||active == 4) ? ysl_active : ysl">
            </template>
          </el-step>
          <el-step title="退回件" v-show="active == 2">
            <template slot="icon">
              <img style="width:18px;" :src="active == -1 ? ysl : active == 2 ? tuihui_active : tuihui">
            </template>
          </el-step>
          <el-step title="已完成">
            <template slot="icon">
              <img style="width:18px;" :src="active == -1 ? ybj : active == 3 ? ybj_active : ybj">
            </template>
          </el-step>
        </el-steps>
      </div>
      <!-- 办理反馈 -->
      <div class="blfk">
        <p class="blfk_title">办理反馈</p>
        <el-table :data="feedBackList" border style="width: 100%">
          <el-table-column prop="handleStatus" label="办理流程">
            <template slot-scope="scope">
              {{ scope.row.handleStatus | formatStatus }}
            </template>
          </el-table-column>
          <el-table-column prop="checkOpinion" label="办理意见">
            <template slot-scope="scope">
              {{ scope.row.checkOpinion || '无' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 办件退回 -->
      <div class="bjth" v-show="active == 2">
        <p class="bjth_title">办件退回</p>
        <el-table :data="sendBackList" border style="width: 100%">
          <el-table-column prop="materialName" label="材料名称">
          </el-table-column>
          <el-table-column label="详情" width="180">
            <template slot-scope="scope">
              <div><span class="download_text" @click="showFiles(scope.row)">详情</span></div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-upload class="upload-demo" :action="action" accept=".xlsx, .xls, .doc, .docx, .pdf, .png, .jpg, .jpeg"
                :on-change="handleChange"
                :on-success="(response, file, fileList) => { return uploadSuccess(response, file, fileList, scope.row) }"
                :before-upload="beforeFileUpload" :file-list="fileList" :limit="1" :on-exceed="handleExceed"
                :before-remove="(file, fileList) => { return removeFile(file, fileList, scope.row) }">
                <span class="download_text">上传</span>
              </el-upload>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="历史上传材料预览" :visible.sync="dialogTableVisible">
          <img :src="historyfileUrl" width="100%">
        </el-dialog>
        <el-button @click="resubmit" style="margin-top: 20px;">重新提交</el-button>
      </div>
    </div>

  </div>
</template>
<script>
import { logout, getHandlingDetails, uploadMaterial } from "@/api/user/index";
import ytj from "../../assets/img/qxxz.png"
import ytj_active from "../../assets/img/qxxz_active.png"
import ysl from "../../assets/img/ysl.png"
import ysl_active from "../../assets/img/ysl_active.png"
import ybj from "../../assets/img/wcsq.png"
import ybj_active from "../../assets/img/wcsq_active.png"
import tuihui from "../../assets/img/tuihui.png"
import tuihui_active from "../../assets/img/tuihui_active.png"
export default {
  data() {
    return {
      loading: false,
      active: 0,
      ytj,
      ytj_active,
      ysl,
      ysl_active,
      ybj,
      ybj_active,
      tuihui,
      tuihui_active,
      fileList: [],
      details: {}, //办件详情
      action: 'http://182.140.209.211:20021/zwmap/uploadMaterialFile',//上传接口地址
      sendBackList: [], //退回件列表
      feedBackList: [],  //反馈列表
      applyId: this.$route.params.applyId || null, //办件id
      dialogTableVisible: false, //退回件材料详情预览，图片预览，其他文件格式则下载
      historyfileUrl: '',  //退回材料预览链接
      newFileUrl: '',  //重新上传材料url
      submitMaterials: [], //退回材料重新上传列表
    };
  },
  created() {
    this.$emit('public_header', true);
    if (sessionStorage.getItem('applyId')) {
      this.applyId = sessionStorage.getItem('applyId')
    }
  },
  mounted() {
    this.getDetail()
  },

  methods: {
    // 办件详情
    getDetail() {
      this.loading = true;
      let obj = {
        applyId: this.applyId
      }
      getHandlingDetails(obj).then((res) => {
        // handleStatus 办件状态( 0:收件 1:办结 2:退回 3:完成)
        // check_status （0：未审 1：通过 2：不通过）
        // console.log('办件详情结果：', res)
        if (res.data.code == 200) {
          if (res.data.data) {
            this.details = res.data.data;
            this.active = this.details.handleStatus;
            let MaterialList = this.details.submitMaterials;  //提交的材料列表
            this.feedBackList = this.details.checkHistories;
            for (let index = 0; index < this.feedBackList.length; index++) {
              if(this.feedBackList[index].handleStatus==4){
                this.feedBackList.splice(index,1)
              }
            }
            MaterialList.forEach(el => {//筛选不通过的材料到退回材料列表
              if (el.checkStatus == 2) {
                this.sendBackList.push(el);
              }
            });
          }
          this.loading = false;
        } else if (res.data.code == 1001) {
          this.$message.error('登录状态已过期，请重新登录！')
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        } else {
          this.$message.error(res.data.msg);
          this.loading = false;
        }
      })
    },
    // 用户下拉菜单
    handleCommand(name) {
      switch (name) {
        case 'Personal':
          this.$router.push({
            name: 'Personal'
          })
          break;
        case 'LoginOut':
          this.LoginOut()
          break;
      }
    },
    // 退出登录
    LoginOut() {
      let params = {
        userId: JSON.parse(localStorage.getItem('userInfo')).userId,
        token: localStorage.getItem('token').toString(),
      }
      logout(params).then((res) => {
        // console.log('退出登录结果：', res)
        if (res.data.code == 200) {
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        } else if (res.data.code == 1001) {
          this.$message.error('登录状态已过期，请重新登录！')
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        }
        else {
          this.$message.error('退出登录失败！')
        }
      })
    },
    // 上传格式校验
    beforeFileUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["pdf", "doc", "docx", "xls", "xlsx", 'png', 'jpg', 'jpeg'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error('上传文件只能是 pdf、doc、docx、xls、xlsx、jpg、jpeg、png格式');
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB');
        return false;
      }
    },
    // 上传文件
    handleChange(file, fileList) {
      // this.fileList = fileList.slice(-3);
      // console.log(file, fileList, '文件上传')
    },
    handleExceed(files, fileList) {
      // console.log(files, fileList, '文件上传')
      // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      this.$message.warning(`此项只能上传一个文件！`);
    },
    // 文件上传成功钩子函数
    uploadSuccess(response, file, fileList, rowInfo) {
      this.newFileUrl = response.url;
      let index = this.submitMaterials.findIndex((el) => el.submitId == rowInfo.submitId)
      if (index != -1) {
        this.submitMaterials[index].url = response.url;
      } else {
        this.submitMaterials.push({ submitId: rowInfo.submitId, url: response.url })
      }

      // console.log(obj, '重新上传材料')
    },
    // 重新提交
    resubmit() {
      let obj = {
        submitMaterials: this.submitMaterials,
        applyId: this.applyId,
        matterId: this.details.matterId
      }
      // console.log(obj, '重新上传材料')
      // 参数：提交材料id：submitId;材料地址 url;申请id applyId;事项id matterId;
      uploadMaterial(obj).then((res) => {
        // console.log('重新上传材料结果', res);
        if (res.data.code == 200) {
          this.$message({
            message: '重新上传材料成功！',
            type: 'success'
          });
          this.$router.go(-1)
        } else if (res.data.code == 1001) {
          this.$message.error('登录状态已过期，请重新登录！')
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 删除上传文件
    removeFile(file, fileList, rowInfo) {
      // console.log('删除上传文件？',rowInfo);
      this.newFileUrl = '';
    },
    showFiles(rowInfo) {
      // console.log('退回材料详情', rowInfo);
      let strIndex = rowInfo.url.lastIndexOf('.');
      if (rowInfo.url != '' && strIndex != -1) {
        let fileFormat = rowInfo.url.slice(strIndex);
        if (fileFormat == '.png' || fileFormat == '.jpg' || fileFormat == '.jpeg') {
          this.historyfileUrl = rowInfo.url;
          this.dialogTableVisible = true;
        } else {
          const link = document.createElement('a');
          // 这里是将链接地址url转成blob地址，
          fetch(rowInfo.url).then(res => res.blob()).then(blob => {
            link.href = URL.createObjectURL(blob)
            // 下载文件的名称及文件类型后缀
            const starIndex = rowInfo.url.lastIndexOf('/');
            const endIndex = rowInfo.url.lastIndexOf('_');
            const exitIndex = rowInfo.url.lastIndexOf('.');
            const name = rowInfo.url.slice(starIndex + 1, endIndex)
            const exitName = rowInfo.url.slice(exitIndex)
            link.download = name + exitName;
            document.body.appendChild(link)
            link.click()
            //在资源下载完成后 清除 占用的缓存资源
            window.URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          });
        }
      } else {
        this.$message.error('暂无历史上传材料！')
      }

    },
  },
  filters: {
    formatStatus(val) {
      if (val == null) return '';
      switch (val) {
        case 0:
          return '收件';
          break;
        case 1:
          return '办结';
          break;
        case 2:
          return '退回';
          break;
        case 3:
          return '完成';
          break;
        case 4:
          return '办结';
          break;  
      }
    }
  }
};
</script>
<style scoped>
.banner {
  height: 155px;
  background-size: 100% auto;
  position: absolute;
  top: 150px;
  width: 100%;
}

.top-title {
  font-size: 40px;
  color: #fff;
  font-weight: bold;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 75%;
}

.cont {
  width: 1200px;
  margin: 0 auto;
}

.jbxx table td,
.blfk table td,
.bjth table td {
  padding: 10px;
  border: 1px solid #E8E9EC;
}

.jbxx .jbxx_title,
.bjjd .bjjd_title,
.blfk .blfk_title,
.bjth .bjth_title {
  padding: 10px;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding-left: 0;
}

.userMenu {
  position: initial;
}

.table_title_bg {
  background-color: #F5F6F8;
}

.download_text {
  color: #43A4EA;
  cursor: pointer;
}
</style>